import {ProductNotesItemResponse } from '@/types/service-response'

export class ProductNote {
  public constructor (
    readonly id: number,
    readonly sachbearbeiter: number | null,
    readonly sachbearbeiterID: number | null,
    readonly herkunft: number,
    readonly noteType: number,
    readonly noteTitle: string,
    readonly responsibleEmployee: number,
    readonly dateStartIso: string | null,
    readonly dateEndIso: string | null,
    readonly alreadyDone: number,
    readonly idMarker: number | null,
    readonly mdt: number | null,
    readonly erstelltVon: number | null,
    readonly isPrivate: boolean,
    readonly author: number | null,
    readonly noteText: string,
    readonly beschreibungRTF: string
  ) {}

  static createFromResponse (responseData: ProductNotesItemResponse[]): Array<ProductNote> {
    let result: Array<ProductNote> = []
    if (responseData) {
      result = responseData.map((item: ProductNotesItemResponse ) => {
        return new ProductNote(
          item.ID,
          item.Sachbearbeiter,
          item.SachbearbeiterID,
          item.Herkunft,
          item.NotizArt,
          item.Titel ? item.Titel : '',
          item.Verantwortlich,
          item.Beginn,
          item.Faellig,
          item.Erledigt,
          item.IDMarker,
          item.MDT,
          item.ErstelltVon,
          item.Privat,
          item.Author,
          item.Beschreibung ? item.Beschreibung : '',
          item.BeschreibungRTF ? item.BeschreibungRTF : '',
        )
      })
    }
    return result
  }
}
